import { Component, Renderer2, OnInit, Inject, AfterViewInit, AfterContentChecked, DOCUMENT } from '@angular/core';

import { trigger, state, style, animate, transition } from '@angular/animations';
import { environment } from '../environments/environment';
import { SidebarService } from '../app/core/services/sidebar.service';
import { AuthenticationService } from './core/services/authentication.service';
import { ProfileService } from './core/services/profile.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({
                transform: 'translate3d(0, 0, 0)'
            })),
            state('out', style({
                transform: 'translate3d(100%, 0, 0)'
            })),
            transition('in => out', animate('400ms ease-in-out')),
            transition('out => in', animate('400ms ease-in-out'))
        ]),
    ],
    standalone: false
})
export class AppComponent {   
    title = 'app';
    public currentYear: number = new Date().getFullYear();

    isProd = environment.production;
    //HasChrome and theme here to support Teams chromeless widget
    hasChrome = true;
    theme: string = undefined;

    private ocelotDisplayed: boolean = false;

    constructor(
        public profile: ProfileService,
        public sidebarService: SidebarService,
        public auth: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router, 
        private modalService: NgbModal,
        private _renderer2: Renderer2,
        @Inject(DOCUMENT) private _document: Document
    ) {
        this.route.queryParamMap
            .subscribe(params => {
                //  This is so we can apply theming to match Teams - https://docs.microsoft.com/en-us/microsoftteams/platform/tabs/how-to/access-teams-context
                if (params.get('theme'))
                    this.theme = "teams-" + params.get('theme');
            });
    }


    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

                // close all open modals
                this.modalService.dismissAll();

            }
        });
    }

    ngAfterContentChecked() {
        // If ocelot has been loaded, but the user is logged out then we need to refresh the page to clear the ocelot js
        if (this.auth.loginState == 0 && this.ocelotDisplayed)
            this.auth.logout(true);
        // If user is logged in and has ocelotbot featureset then load ocelot js
        if (this.auth.loginState != 0 && this.auth.hasFeature("OcelotBot") && !this.ocelotDisplayed && !!this.profile.settings) {
            this.ocelotDisplayed = true;
            // Load Ocelot chat bot for the featureset
            let script = this._renderer2.createElement('script');

            //get src from settings (OcelotBotUrl)
            script.src = this.profile.settings.ocelotbotUrl;

            this._renderer2.appendChild(this._document.body, script);
        }
    }

    ngAfterViewInit() {
        
    } 

    public get isInspector(): boolean {
        return this.auth.token && this.auth.token.isFound && this.auth.token.payload["Kfbs.Environment.View"];
    }

    public isDashboard() {
        var url = this.router.url;

        if (url.indexOf('dashboard') != -1)
            return true
        return false;

        //return this.router.url === '/dashboard';
    }
}
